// extracted by mini-css-extract-plugin
export var chevron = "_p2-1";
export var clickable = "_p2-0";
export var ruleRow = "_p2-2";